import React from 'react'
import { createGlobalStyle } from 'styled-components'

const VisxStyles = createGlobalStyle`
    .visx-tooltip-glyph svg {
        overflow: visible;
        width: 10px;
        height: 10px;
    }
`
// This fixes the Login image from looking squished. Will be fixed in the
// next gecko-ui release
const LoginDropdownCorrection = createGlobalStyle`
    div:has(div > div > div > img[alt="User profile"] ) {
        padding: 0 !important;

        &:focus {
            border: none;
        }
    }
`

const CenterTitle = createGlobalStyle`
    #HeaderContainer {
        grid-template-columns: 4fr min-content;
    }
`

const LoginMenuItem = createGlobalStyle`
    div[data-radix-popper-content-wrapper=""] div[role="menuitem"]:has(span,div[role="group"]) {
        min-width: 13rem;
    }
`

const FooterStyles = createGlobalStyle`
    footer.ant-layout-footer {
        color: ${({ theme }) => theme.forecast.text3} !important;
        padding-top: 10px;
    }

    footer {
        display: none;
    }
`
const AdvancedControls = createGlobalStyle`
    .radix-themes:where([data-is-root-theme='true']) {
        min-height: 100px;
        box-shadow: none;
    }
`
const HeaderHeight = createGlobalStyle`
    #AppLayoutGrid {
        grid-template-rows: 4.375rem 1fr;
    }
`

const LoginDropDownProfile = createGlobalStyle`
    div[aria-label="Login dropdown"] {
        & div:nth-child(1) {
            flex-grow: 1;
        }

        & div:nth-child(2) {
            flex-shrink: 10;
            @media screen and (${({ theme }) => theme.queries.laptopAndSmaller}) {
                display: none;
            }
        }
    }
`

const Button = createGlobalStyle`
    .rs-btn-default:hover {
        background-color: ${({ theme }) => theme.forecast.background2} !important;
    }
`

const Picker = createGlobalStyle`
    .rs-btn.rs-picker-toggle {
        background-color: ${({ theme }) => theme.forecast.background1} !important;
    }

    .rs-picker-toggle-textbox {
        color: ${({ theme }) => theme.forecast.text1};
    }

    .rs-picker-list-item {
        background-color: ${({ theme }) => theme.forecast.background1} !important;
        color: ${({ theme }) => theme.forecast.text1};
    }

    .rs-check-item:hover {
        background-color: ${({ theme }) => theme.forecast.background2_5} !important;
    }

    .rs-picker-toggle-placeholder {
        color: ${({ theme }) => theme.forecast.text2} !important;
    }
    
    .rs-picker-toggle-indicator {
        svg {
            color: ${({ theme }) => theme.forecast.text2} !important;
        }
    }

    .rs-input-group, .rs-search-box-input {
        background-color: ${({ theme }) => theme.forecast.background2} !important;
        color: ${({ theme }) => theme.forecast.text1};
    }
`

const PickerPopup = createGlobalStyle`
    div[data-testid="picker-popup"] {
        background-color: ${({ theme }) => theme.forecast.background1};
        z-index: 1000;
    }
`

const DateRangePickerButtonLink = createGlobalStyle`
    .rs-btn.rs-btn-link.rs-btn-sm {
        color: ${({ theme }) => theme.forecast.border};
    }
`

const DateRangePickerDateFocus = createGlobalStyle`
    .rs-calendar-table-cell-is-today .rs-calendar-table-cell-content {
        -webkit-box-shadow: inset 0 0 0 1px ${({ theme }) => theme.forecast.border} !important;
        box-shadow: inset 0 0 0 1px ${({ theme }) => theme.forecast.border} !important;
    }
`

const DateRangePickerOkButton = createGlobalStyle`
    .rs-btn-primary.rs-btn-disabled, .rs-btn-primary:disabled {
        color: ${({ theme }) => theme.forecast.background1};
        background-color: ${({ theme }) => theme.forecast.text1};
    }

    .rs-btn-primary.rs-btn-active, .rs-btn-primary:hover {
        color: ${({ theme }) => theme.forecast.text1};
        background-color: ${({ theme }) => theme.forecast.background2_5};
    }

    .rs-btn-primary {
        color: ${({ theme }) => theme.forecast.background1};
        background-color: ${({ theme }) => theme.forecast.text1};
    }
`

const DateRangePickerCells = createGlobalStyle`
    --rs-btn-subtle-hover-text: ${({ theme }) => theme.forecast.text1};
    --rs-btn-subtle-hover-bg: ${({ theme }) => theme.forecast.background2};

    .rs-btn-icon {
        color: ${({ theme }) => theme.forecast.icon1};
    }

    .rs-calendar-header-title {
        color: ${({ theme }) => theme.forecast.text2};
    }

    .rs-calendar-table-header-cell-content {
        color: ${({ theme }) => theme.forecast.text2};
    }

    .rs-calendar-table-cell-un-same-month .rs-calendar-table-cell-content {
        color: ${({ theme }) => theme.forecast.text3};
    }

    .rs-calendar-table-cell-content {
        color: ${({ theme }) => theme.forecast.text1};
    }

    .rs-calendar-table-cell-selected .rs-calendar-table-cell-content {
        color: ${({ theme }) => theme.forecast.text1};
        background-color: ${({ theme }) => theme.forecast.background3};
    }

    .rs-picker-popup .rs-calendar .rs-calendar-table-cell:hover .rs-calendar-table-cell-content {
        background-color: ${({ theme }) => theme.forecast.background3};
    }

    .rs-calendar-table-cell-in-range:before {
        background-color: ${({ theme }) => theme.forecast.background3};
    }
`

const DateRangePickerInput = createGlobalStyle`
    .rs-input-group ::placeholder {
        color: ${({ theme }) => theme.forecast.text3};
    }

    .rs-picker-input-group.rs-input-group {
        background-color: ${({ theme }) => theme.forecast.background3};
    }
    
    .rs-picker-input-group.rs-input-group input {
        background-color: ${({ theme }) => theme.forecast.background1};
        color: ${({ theme }) => theme.forecast.text1};
    }

    .rs-input-group:focus-within, .rs-input-group:not(.rs-input-group-disabled).rs-input-group-focus, .rs-input-group:not(.rs-input-group-disabled):hover {
        border-color: ${({ theme }) => theme.forecast.background3} !important;
        color: ${({ theme }) => theme.forecast.text1} !important;
    }

    .rs-input-group:focus-within, .rs-input-group:not(.rs-input-group-disabled).rs-input-group-focus, .rs-input-group:not(.rs-input-group-disabled) {
        border-color: ${({ theme }) => theme.forecast.background3} !important;
        color: ${({ theme }) => theme.forecast.text1} !important;
    }

    .rs-picker-daterange > .rs-input-group.rs-input-group-inside .rs-input {
        background-color: ${({ theme }) => theme.forecast.background3} !important;
        color: ${({ theme }) => theme.forecast.text1} !important;
    }

    .rs-picker-daterange > .rs-input-group.rs-input-group-inside .rs-input::placeholder {
        background-color: ${({ theme }) => theme.forecast.background3} !important;
        color: ${({ theme }) => theme.forecast.background4} !important;
    }

    .rs-picker-clean:has(.rs-icon) {
        color: ${({ theme }) => theme.forecast.text4} !important;
    }

`

const DateRangePickerCloseButton = createGlobalStyle`
    .rs-icon {
        color: ${({ theme }) => theme.forecast.icon1};
    }

    .rs-btn-close {
        color: ${({ theme }) => theme.forecast.icon1};
    }

    .rs-btn-close:focus svg path, .rs-btn-close:hover svg path {
        color: ${({ theme }) => theme.forecast.icon1};
        stroke: ${({ theme }) => theme.forecast.icon1};
    }
`

const SelectorInputRsuite = createGlobalStyle`
    .rs-picker-toggle-value {
        color: ${({ theme }) => theme.forecast.text1} !important;
    }

    .rs-picker-select-menu-item, .rs-picker-select-menu-item-active, .rs-picker-select-menu-item-focus {
        background-color: ${({ theme }) => theme.forecast.background1} !important;
        color: ${({ theme }) => theme.forecast.text1} !important;

        &:hover {
            background-color: ${({ theme }) => theme.forecast.background3} !important;
        }
    }
`

const CheckPickerRsuite = createGlobalStyle`
    .rs-checkbox-checked .rs-checkbox-control .rs-checkbox-inner:before {
        background-color: ${({ theme }) => theme.forecast.border} !important;
        border-color: ${({ theme }) => theme.forecast.border} !important;
    }

    .rs-picker-value-count {
        background-color: ${({ theme }) => theme.forecast.background4} !important;
    }
`

const ManageUsersTable = createGlobalStyle`
    .manage-permissions-page .ant-table-cell-row-hover {
        cursor: pointer;
    }

    .manage-permissions-page .ant-table-cell {
        vertical-align: top
    }

    .manage-permissions-page .ant-table-wrapper .ant-table-filter-trigger.active {
        color: ${({ theme }) => theme.forecast.background2};
        background-color: ${({ theme }) => theme.colors.highVis};
    }

    .manage-permissions-page .ant-table-wrapper .ant-table-filter-trigger.active:hover {
        filter: brightness(130%);
    }
`

const AntdModalStyles = createGlobalStyle`
    .ant-modal-footer {
        button {
            box-shadow: none;
            &.ant-btn-variant-solid {
                background-color: ${({ theme }) => theme.colors.highVis} !important;
                color:black;
                font-weight: 500;
            }

            &.ant-btn-variant-solid:hover {
                background-color: #F5FF99 !important;
                color: black !important;
            }

            &.ant-btn-variant-outlined:hover {
                background-color: rgba(51, 51, 51, 1) !important;
            }
        }
    }
`

export const GlobalStyles = () => (
  <>
    <AntdModalStyles />
    <LoginDropDownProfile />
    <HeaderHeight />
    <CenterTitle />
    <FooterStyles />
    <VisxStyles />
    <LoginDropdownCorrection />
    <LoginMenuItem />
    <AdvancedControls />
    <PickerPopup />
    <DateRangePickerButtonLink />
    <DateRangePickerDateFocus />
    <DateRangePickerOkButton />
    <DateRangePickerCells />
    <DateRangePickerInput />
    <DateRangePickerCloseButton />
    <Picker />
    <Button />
    <SelectorInputRsuite />
    <CheckPickerRsuite />
    <ManageUsersTable />
  </>
)
